import { render, staticRenderFns } from "./_mobile.tab.vue?vue&type=template&id=1dfc508f&"
import script from "./_mobile.tab.vue?vue&type=script&lang=js&"
export * from "./_mobile.tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports